import { DateTime } from 'luxon'

import type { OrderItemModel } from '@models/types'

// Orders without a due date (or an unparseable one) sort after every dated order item
export const getDueDateTimestamp = (orderItem: OrderItemModel | undefined) => {
  const dueDateString = orderItem?.dates?.due?.date

  if (!dueDateString) return Infinity

  const date = DateTime.fromFormat(dueDateString, 'dd/MM/yyyy')

  return date.isValid ? date.toMillis() : Infinity
}

export const sortOrderItemIdsByDueDate = (
  orderItemIds: number[],
  orderItemsById: Record<number, OrderItemModel>,
) => [...orderItemIds].sort((a, b) => (
  getDueDateTimestamp(orderItemsById[a]) - getDueDateTimestamp(orderItemsById[b])
))
